export default {"src":"/_next/static/media/dogEmergency_40.80f74df5.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};